import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { startUrl } from "../App";

const UserProtectedRoute = () => {
  let authObj = null;
  try {
    const authStr = localStorage.getItem("auth");
    if (authStr && authStr !== "true") {
      authObj = JSON.parse(authStr);
    } else if (authStr === "true") {
      // Legacy fallback
      authObj = { role: "user" };
    }
  } catch (e) {
    console.error("Failed to parse auth", e);
  }

  if (!authObj || authObj.role !== "user") {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default UserProtectedRoute;
